// @flow
import React, {useCallback, useState} from 'react';

import {navigate} from '../../../lib/helpers';
import {budgetLineItemApi} from '../../../lib/api';
import type {BudgetLineItem} from '../../../lib/types';

import CommonCardPage from '../../../components/hoc/common/handbook/CardPage';
import InnerForm from './components/InnerForm';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/expense-direction/budget-line-item';

export default (props: PageProps) => {
  const [data: BudgetLineItem, setData] = useState({
    id: props.id
  });

  // const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await budgetLineItemApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: BudgetLineItem) => {
    let id = payload.id;
    if (id) {
      await budgetLineItemApi.update(payload);
    } else {
      await budgetLineItemApi.add(payload);
    }
    await navigate(`${entryPointPath}`);
  };

  const onCancel = async () => {
    await navigate(`${entryPointPath}`, true);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs: [
          {
            to: '/admin/expense-direction/budget-line-item',
            name: 'Список статей бюджетной формы'
          },
          { name: 'Статья бюджетной формы' }
        ],
        mainHeader: 'Статья бюджетной формы'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
